import { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * Zugang zur Sitzung: Adresse und QR-Code.
 *
 * Lokale Kopie von offsites/ar/slides/_zugang.tsx — der Strategietag hat eine
 * eigene Domain und einen eigenen Login (Einmal-Code statt Gruppen-PIN, siehe
 * offsite.config.ts). Anders als bei den Gremien gibt es hier keine feste PIN
 * am Beamer: Jede Person tippt ihren eigenen Code ein oder scannt ihn über
 * einen persönlichen Link — deshalb zeigt diese Folie nur Adresse und
 * Kamera-Code, keinen gemeinsamen Zugangswert.
 *
 * Steht auf zwei Folien — auf der Warte-Folie, wo er die Hauptsache ist, und
 * auf der Themenwahl, wo er nebenher weiterläuft: Wer während der Diskussion
 * über das Thema dazukommt, soll sich noch anmelden können, ohne dass der
 * Moderator zurückblättern muss.
 */

const WORKSHOP_URL = import.meta.env.VITE_WORKSHOP_URL ?? "https://ki.svoos.de/";

/**
 * Mehrfach einlösbarer Publikums-Code (am 15.09.2026 über POST /admin/codes
 * mit `publikum: true` erzeugt, Label „Publikum CD Kaserne"). Der Leinwand-QR
 * trägt ihn als `?p=` — Scannen loggt direkt als Hintergrund ein, ohne Tippen.
 * Die 6 Bühnen-Plätze kommen über ihre eigenen Karten-QRs (Einmal-Codes)
 * herein. Kein Geheimnis: Der Code steht ohnehin groß auf der Leinwand.
 */
const PUBLIKUMS_CODE = "J5CEXC";

export function loginUrl(): string {
  const u = new URL(WORKSHOP_URL);
  if (!u.pathname || u.pathname === "/") u.pathname = "/m/login";
  u.searchParams.set("p", PUBLIKUMS_CODE);
  return u.toString();
}

export const zugangsAdresse = WORKSHOP_URL.replace(/^https?:\/\//, "").replace(/\/$/, "");

/** QR-Code als SVG. `groesse` steuert nur die CSS-Klasse, nicht die Auflösung. */
export function QrCode({ klein = false }: { klein?: boolean }) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    QRCode.toString(loginUrl(), {
      type: "svg",
      errorCorrectionLevel: "H",
      margin: 0,
      color: { dark: "#161B21", light: "#FFFFFF" },
    })
      .then(setSvg)
      .catch(() => setSvg(null));
  }, []);

  return (
    <div className={`ar-qr${klein ? " ar-qr-klein" : ""}`}>
      {svg ? (
        <span
          aria-hidden="true"
          style={{ display: "block", width: "100%", height: "100%" }}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ) : (
        <div className="ar-qr-fallback">QR-Code wird erzeugt …</div>
      )}
    </div>
  );
}
